import { Injectable } from '@angular/core';
import { HttpHeaders, HttpClient } from '@angular/common/http';

import { Observable, throwError } from 'rxjs';
import { catchError, retry, map } from 'rxjs/operators';
import { ConstantsService } from '../common/services/constants.service';

const httpOptions = {     
    headers: new HttpHeaders({       
        'Content-Type':  'application/json;charset=utf-8', 
        'Authorization': ConstantsService.AUTH_TOKEN,
    })    
};

@Injectable()
export class AuthenticationService {

    constructor(private http: HttpClient) { }

    login(rootUrl: string, usercode: string, id_student: number):Observable<any> {      
        return this.http.post<any>(rootUrl+'loginByCode', {login_code:usercode, id_student: id_student, os:'web', notId:'', build:''}, httpOptions)
            .pipe(map(user => {
                return user;
            }));
    }
    /** 
   *  user-Login
   */
    userlogin(rootUrl: string, username: string, passw: string): Observable<any> {
        return this.http.post<any>(rootUrl + 'studentSelf/studentLogin', { username: username, password: passw, notification_id: '' }, httpOptions)
            .pipe(map(user => {
                return user;
            }));
    }
     /** 
   *  forget-password
   */
    forgetPassword(rootUrl: string, username: string): Observable<any> {
        return this.http.post<any>(rootUrl + 'studentSelf/forgotPassword', { username: username }, httpOptions)
            .pipe(map(user => {
                return user;
            }));
    }   

      /** 
   *  reset-password
   */
    resetPassword(rootUrl: string,id_self_student:number, password: string): Observable<any> {
        return this.http.post<any>(rootUrl + 'studentSelf/resetPassword', { id_self_student: id_self_student, password: password }, httpOptions)
            .pipe(map(user => {
                return user;
            }));
    }

      /** 
   *  change-password
   */
    changePassword(rootUrl: string,id_self_student:number, old_password: string, new_password:string, usertoken: string): Observable<any> {
        return this.http.post<any>(rootUrl + 'studentSelf/changePassword', { id_self_student: id_self_student, old_password: old_password, new_password: new_password, usercode: usertoken}, httpOptions)
            .pipe(map(user => {
                return user;
            }));
    }
    loginstatus(rootUrl: string, usercode: string, student_id: number): Observable<any> {
        return this.http.post<any>(rootUrl + 'loginstatus', { usercode: usercode, student_id: student_id }, httpOptions)
            .pipe(map(user => {
                return user;
            }));
    }
    studentprofile(rootUrl: string,id_self_student:number, usertoken: string): Observable<any> {
        return this.http.post<any>(rootUrl + 'studentSelf/getStudentProfile', {id_self_student: id_self_student, usercode: usertoken}, httpOptions)
            .pipe(map(user => {
                return user;
            }));
    }   
    forgetUsername(rootUrl: string, mobile_no: string): Observable<any> {
        return this.http.post<any>(rootUrl + 'studentSelf/forgotUsername', { mobile_no: mobile_no }, httpOptions)
            .pipe(map(user => {
                return user;
            }));
    }  
 /*    updateUsername(rootUrl: string, userId: string, id_student:number): Observable<any> {
        return this.http.post<any>(rootUrl + 'student/userIdUpdate', { userId: userId, student_id: id_student }, httpOptions)
            .pipe(map(user => {
                return user;
            }));
    }*/ 
     /** 
   *  dashboard-mock-exam
   */
   mockExam(rootUrl: string,id_student:number, pg:number, usertoken: string): Observable<any> {
        return this.http.post<any>(rootUrl + 'studentSelf/fetchDashboardExamList', {id_self_student: id_student, pg: pg, usercode: usertoken}, httpOptions)
            .pipe(map(user => {
                return user;
            }));
    } 
     /** 
   *  dashboard-mock-exam
   */
   pastExam(rootUrl: string,id_student:number, pg:number, usertoken: string): Observable<any> {
        return this.http.post<any>(rootUrl + 'studentSelf/fetchAttemptedExamList', {id_self_student: id_student, pg: pg, usercode: usertoken}, httpOptions)
            .pipe(map(user => {
                return user;
            }));
    }   
   loadResult(rootUrl: string,id_student:number, id_self_student:number, id_exam:number, usertoken: string): Observable<any> {
        return this.http.post<any>(rootUrl + 'studentSelf/getResultPdf', {id_student: id_student, id_self_student: id_self_student, id_exam: id_exam, usercode: usertoken}, httpOptions)
            .pipe(map(user => {
                return user;
            }));
    }      
    loginmock(rootUrl: string, usercode: string, id_student: number):Observable<any> {      
        return this.http.post<any>(rootUrl+'studentSelf/mockLogin', {login_code:usercode, id_student: id_student, os:'web', notId:'', build:''}, httpOptions)
            .pipe(map(user => {
                return user;
            }));
    }  
    loginwithotp(rootUrl: string, mobile_no: number):Observable<any> {      
        return this.http.post<any>(rootUrl+'studentSelf/loginWithMobile', {mobile_no:mobile_no}, httpOptions)
            .pipe(map(user => {
                return user;
            }));
    }  
    highestquali(rootUrl: string):Observable<any> {      
        return this.http.post<any>(rootUrl+'getHighQualList', {}, httpOptions)
            .pipe(map(user => {
                return user;
            }));
    }     
    states(rootUrl: string):Observable<any> {      
        return this.http.post<any>(rootUrl+'studentSelf/getStates', {}, httpOptions)
            .pipe(map(user => {
                return user;
            }));
    } 
    cities(rootUrl: string, id_state: number):Observable<any> {      
        return this.http.post<any>(rootUrl+'studentSelf/getCities', {id_state:id_state}, httpOptions)
            .pipe(map(user => {
                return user;
            }));
    } 
    checkUsername(rootUrl: string, userId: string, id_student:number): Observable<any> {
        return this.http.post<any>(rootUrl + 'studentSelf/userIdCheck', { userId: userId }, httpOptions)
            .pipe(map(user => {
                return user;
            }));
    }   
    register(rootUrl: string, student_name: string, gender: number, date_of_birth: number, id_hq: number, email_id: string, mobile: string, id_state: number, id_city: number, user_name: string, password: string): Observable<any> {
        return this.http.post<any>(rootUrl + 'studentSelf/register', { student_name: student_name, gender: gender, date_of_birth: date_of_birth, id_hq: id_hq, email_id: email_id, mobile: mobile, id_state: id_state, id_city: id_city, user_name: user_name, password: password}, httpOptions)
            .pipe(map(user => {
                return user;
            }));
    }  
    getSectors(rootUrl: string, id_self_student:number, usertoken: string): Observable<any> {
        return this.http.post<any>(rootUrl + 'studentSelf/fetchSectors', { id_self_student: id_self_student, usercode: usertoken }, httpOptions)
            .pipe(map(user => {
                return user;
            }));
    }           
    setSectors(rootUrl: string, id_self_student:number, usertoken: string, id_sector: number, select: number): Observable<any> {
        return this.http.post<any>(rootUrl + 'studentSelf/selectSector', { id_self_student: id_self_student, usercode: usertoken, id_sector: id_sector, select: select }, httpOptions)
            .pipe(map(user => {
                return user;
            }));
    }                          
    getQPs(rootUrl: string, id_self_student:number, usertoken: string, id_sector: number): Observable<any> {
        return this.http.post<any>(rootUrl + 'studentSelf/fetchQPList', { id_self_student: id_self_student, usercode: usertoken, id_sector: id_sector }, httpOptions)
            .pipe(map(user => {
                return user;
            }));
    }           
    getEaxmQP(rootUrl: string, id_self_student:number, usertoken: string, id_qp: number): Observable<any> {
        return this.http.post<any>(rootUrl + 'studentSelf/fetchExamListViaQP', { id_self_student: id_self_student, usercode: usertoken, id_qp: id_qp }, httpOptions)
            .pipe(map(user => {
                return user;
            }));
    }   
    getInstructions(rootUrl: string, id_self_student:number, usertoken: string): Observable<any> {
        return this.http.post<any>(rootUrl + 'studentSelf/fetchInstructions', { id_self_student: id_self_student, usercode: usertoken }, httpOptions)
            .pipe(map(user => {
                return user;
            }));
    }   
    updateProfile(rootUrl: string, id_self_student:number, usertoken: string, name: string, gender: number, dob: number, id_hq: number, id_state: number, id_city: number, email: string, mobile: string): Observable<any> {
        return this.http.post<any>(rootUrl + 'studentSelf/updateProfileWeb', { id_self_student: id_self_student, usercode: usertoken, name: name, gender: gender, dob: dob, id_hq: id_hq, id_state: id_state, id_city: id_city, email: email, mobile: mobile}, httpOptions)
            .pipe(map(user => {
                return user;
            }));
    }   
    resultStats(rootUrl: string, id_self_student:number, usertoken: string): Observable<any> {
        return this.http.post<any>(rootUrl + 'studentSelf/fetchDashboardStatistics', { id_self_student: id_self_student, usercode: usertoken}, httpOptions)
            .pipe(map(user => {
                return user;
            }));
    }  
    getResults(rootUrl: string, id_self_student:number, usertoken: string, student_id: number, exam_id: number): Observable<any> {
        return this.http.post<any>(rootUrl + 'studentSelf/getAllResultPdf ', { id_self_student: id_self_student, usercode: usertoken, id_student: student_id, id_exam: exam_id }, httpOptions)
            .pipe(map(user => {
                return user;
            }));
    }  
    getPaidExamDetails(rootUrl: string, id_self_student:number, usertoken: string, exam_id: number): Observable<any> {
        return this.http.post<any>(rootUrl + 'student/getPaidExamDetails ', { id_self_student: id_self_student, usercode: usertoken, id_exam: exam_id }, httpOptions)
            .pipe(map(user => {
                return user;
            }));
    }          
    applycoupon(rootUrl: string, id_self_student:number, usertoken: string, promo: string): Observable<any> {
        return this.http.post<any>(rootUrl + 'studentSelf/applyPromo', { id_self_student: id_self_student, usercode: usertoken, promo: promo }, httpOptions)
            .pipe(map(user => {
                return user;
            }));
    }  
    createOrder(rootUrl:string, usercode: string, id_self_student:number, id_exam:number, id_promo:number):Observable<any> {
        return this.http.post<any>(rootUrl+'studentSelf/payment/createPayment', {usercode:usercode, id_self_student:id_self_student, id_exam:id_exam, id_promo:id_promo}, httpOptions)
            .pipe(map(user => {
                return user;
            }));
    } 
    updateOrder(rootUrl:string, usercode: string, id_self_student:number, id_exam:number, id_student_payments:number, razorpay_payment_id:string):Observable<any> {
        return this.http.post<any>(rootUrl+'studentSelf/payment/updatePayment', {usercode:usercode, id_self_student:id_self_student, id_exam:id_exam, id_student_payments:id_student_payments, razorpay_payment_id:razorpay_payment_id}, httpOptions)
            .pipe(map(user => {
                return user;
            }));
    }  
    getTransactions(rootUrl: string, id_self_student:number, usertoken: string): Observable<any> {
        return this.http.post<any>(rootUrl + 'studentSelf/fetchAllTransactions', { id_self_student: id_self_student, usercode: usertoken }, httpOptions)
            .pipe(map(user => {
                return user;
            }));
    }             
    refundRequestsubmit(rootUrl: string, usertoken: string, id_self_student:number, refund_request_reason:string, refund_amount:number, id_student_payments:number, order_id:string, id_exam_fee:number, id_exam:number): Observable<any> {
        return this.http.post<any>(rootUrl + 'studentSelf/requestRefund', { usercode: usertoken, id_self_student: id_self_student, refund_request_reason:refund_request_reason, refund_amount:refund_amount, id_student_payments:id_student_payments, order_id:order_id, id_exam_fee: id_exam_fee, id_exam: id_exam }, httpOptions)
            .pipe(map(user => {
                return user;
            }));            
    }
    authStage(rootUrl: string, usercode: string, student_id: number, exam_id:number, auth_stage:number): Observable<any> {
        return this.http.post<any>(rootUrl + 'student/addAuthStage', { usercode: usercode, student_id: student_id, exam_id: exam_id, auth_stage:auth_stage }, httpOptions)
            .pipe(map(user => {
                return user;
            }));            
    }
    logout() {
        // remove user from local storage to log user out
        localStorage.removeItem('currentUser');
        sessionStorage.removeItem("pkshn_exam_set");
        sessionStorage.removeItem("pkshn_dexam_set");
        localStorage.clear();
        sessionStorage.clear();               
    }
}